/// <amd-module name="VSSUI/Utilities/DropdownSelection" />
import { ListSelection } from "VSSUI/List";

export class DropdownSelection extends ListSelection {
    public constructor() {
        super({ selectOnFocus: false });
    }
}

export class DropdownMultiSelection extends ListSelection {
    public constructor() {
        super({ alwaysMerge: true, multiSelect: true, selectOnFocus: false });
    }
}
